import { TeamTaskCounts } from '../../client';

interface TeamFeatureCellProps {
  teamData: TeamTaskCounts | undefined;
}

type StatusCategory = {
  key: keyof TeamTaskCounts;
  label: string;
  color: string;
};

const STATUS_CATEGORIES: StatusCategory[] = [
  { key: 'done', label: 'Done', color: 'bg-feedback-success' },
  { key: 'in_progress', label: 'In Progress', color: 'bg-feedback-warning' },
  { key: 'blocked', label: 'Blocked', color: 'bg-feedback-error' },
  { key: 'committed', label: 'Committed', color: 'bg-action-primary' },
  { key: 'todo', label: 'Todo', color: 'bg-bg-muted' },
];

export function TeamFeatureCell({ teamData }: TeamFeatureCellProps) {
  if (!teamData) {
    return (
      <div className="w-full h-full flex items-center justify-center p-2">
        <p className="text-center text-text-disabled text-xs">No work here for this team</p>
      </div>
    );
  }

  const total = teamData.todo + teamData.committed + teamData.in_progress + teamData.blocked + teamData.done;
  const visibleCategories = STATUS_CATEGORIES.filter((c) => teamData[c.key] > 0);

  return (
    <div className="flex items-center justify-center p-2">
      <div
        className="flex h-6 w-full rounded-md overflow-hidden"
        title={visibleCategories.map((c) => `${c.label}: ${teamData[c.key]}`).join(', ')}
      >
        {STATUS_CATEGORIES.map((category) => {
          const value = teamData[category.key];
          if (value <= 0) return null;
          const width = total > 0 ? `${(value / total) * 100}%` : '0%';
          const isFirst = visibleCategories[0]?.key === category.key;
          const isLast = visibleCategories[visibleCategories.length - 1]?.key === category.key;

          return (
            <div
              key={category.key}
              className={`${category.color} transition-all hover:brightness-110 ${isFirst ? 'rounded-l-md' : ''} ${isLast ? 'rounded-r-md' : ''}`}
              style={{ width }}
            />
          );
        })}
      </div>
    </div>
  );
}
